import { Directive, HostListener, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ImportService } from '@services/import/import.service';
import { MenuService } from '@services/menu.service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { ImportDialogComponent } from './import-dialog/import-dialog.component';

const dialogMargin = 70;
const headerHeight = 50;

@Directive({
  selector: '[appOpenImportDialog]'
})
export class OpenImportDialogDirective implements OnDestroy {
  private readonly subscriptions: Subscription[] = [];
  public halfSized = false;
  private dialogRef: MatDialogRef<ImportDialogComponent>;

  constructor(public dialog: MatDialog, private readonly menu: MenuService, private readonly importService: ImportService) {
    const maximizedSubscription = this.importService.isMaximizedListener.pipe(distinctUntilChanged()).subscribe(value => {
      this.updateDialogSize();
    });
    const halfSizedSubscription = this.importService.isHalfSizedListener.pipe(distinctUntilChanged()).subscribe(value => {
      this.updateDialogSize();
    });

    this.subscriptions.push(maximizedSubscription, halfSizedSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  public async openDialog() {
    const dialogOptions = {
      height: 'calc(100% - 140px)',
      width: 'calc(100% - 140px)',
      position: { bottom: '' },
      maxWidth: '100vw',
      panelClass: ['ui-dialog-content'],
      disableClose: true,
      closeOnNavigation: false
    };

    this.dialogRef = this.dialog.open(ImportDialogComponent, dialogOptions);
  }

  private updateDialogSize() {
    if (this.dialogRef) {
      try {
        if (this.importService.isMaximized) {
          if (this.importService.isHalfSized) {
            this.dialogRef.updatePosition({ bottom: `0px !important`, right: `30px !important` });
            this.dialogRef.updateSize(`calc(50% - ${dialogMargin}px)`, `calc(100% - ${headerHeight}px)`);
          } else {
            this.dialogRef.updatePosition({ bottom: `0px !important`, right: `` });
            this.dialogRef.updateSize(`100%`, `calc(100% - ${headerHeight}px)`);
          }
        } else {
          if (this.importService.isHalfSized) {
            this.dialogRef.updatePosition({ bottom: ``, right: `${dialogMargin}px !important` });
            this.dialogRef.updateSize(`calc(50% - ${dialogMargin}px)`, `calc(100% - ${dialogMargin * 2}px)`);
          } else {
            this.dialogRef.updatePosition({ bottom: ``, right: `` });
            this.dialogRef.updateSize(`calc(100% - ${dialogMargin * 2}px)`, `calc(100% - ${dialogMargin * 2}px)`);
          }
        }
      } catch (error) {
      } finally {
        this.menu.emitResize();
      }
    }
  }
}
